<template lang='pug'>
  v-container(pa-0='' )
      v-form(ref="form"  v-model="valid")
          v-row(style='display;flex; flex-direction:row; flex-wrap: wrap;')
            v-col(cols="12")
              v-text-field(v-model='model.email' type='email' :rules='emailRules' label='Email' required='')
              v-text-field(v-model='model.password' type='password' :rules='pswRules' label='Contraseña' required='')
              v-select(:items='roles'
                label='Rol'
                :rules='rolRules'
                v-model='model.role'
                item-text="text"
                item-value="value"
                @change="resetForm")
              v-select(
                disabled
                :items="shops"
                name="shop"
                label="Seleciona una tienda"
                v-model="shop"
                item-text="name"
                item-value="id"
                multiple
                chips,
                required,
                :rules='shopRules')
          v-btn(@click="cancel()") Cancelar
          v-btn(color='#008e95', @click='validate' :loading="isLoading" :disabled='validForm()')
              | GUARDAR
</template>
<script>
  import Swal from 'sweetalert2'
  export default {
    props: {
      model: Object,
      onSave: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        valid: true,
        valueType: '',
        show: false,
        isMobile: false,
        emailRules: [
          v => !!v || 'email requerido',
          v => /.+@.+\..+/.test(v) || 'email invalido',
        ],
        pswRules: [
          v => !!v || 'Contraseña requerida',
        ],
        rolRules: [
          v => !!v || 'Rol requerido',
        ],
        shopRules: [
          v => !!v || 'Tienda requerida',
        ],
        roles: [
          { text: 'Cocinero', value: 'chef' },
          { text: 'Mesero', value: 'waiter' },
        ],
      }
    },
    computed: {

      user () {
        return this.$store.state.users.user
      },
      shops () {
        return this.$store.getters['shops/getItems']
      },
      isLoading () {
        // console.log(this.$store.getters['admins/getLoading'])
        return this.$store.getters['admins/getLoading']
      },
      shop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      employees () {
        return this.$store.getters['restaurant/getEmployees']
      },

    },
    methods: {
      validForm () {
        const vm = this
        if (!vm.model.role || !vm.model.email || !vm.model.password) {
          return true
        } else {
          return false
        }
      },
      async validate () {
        const vm = this
        const found = await vm.employees.some(e => e.data.role === vm.model.role)
        if (found) {
          Swal.fire({
            icon: 'error',
            title: 'Ya existe un colaborador creado',
            text: 'Solo puede existir un colaborador con el rol Cocinero o Mesero',
          })
          return
        }
        vm.model.shops.push(vm.shop.id)
        vm.$store.commit('admins/SET_LOADING', true)
        vm.onSave()
        vm.snackbar = true
      },
      cancel () {
        this.$emit('cancel')
      },
      resetForm () {
        const vm = this
        vm.model.shops = []
      },
    },
  }
</script>
<style scoped lang="scss">
    $break-large: 1200px;
    $primary-color: #c29f52;
    .grid-picker{
        text-align: center;
        min-width: 100%;
        display: grid;
        position: relative;
        flex: 1;
        width: 100%;
        grid-template-areas:

                'picture picture '
                'title title '
                'button button';
        @media screen and (min-width: $break-large) {
            grid-template-areas:

                    'title picture picture '
                    'title picture picture '
                    'button button button';
            .image-slot{
                min-width: 400px;
                height: 250px;
                overflow: hidden;
            }
        }

        grid-gap: 10px;

        padding: 10px;
        .picker-btn{

            grid-area: button;
            flex: 1;
            height: 50px;
        }
        .image-slot{
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            display: flex;
            grid-area: picture;
            max-width: 350px;
            max-height: 250px;
            background: #9e9e9e;
            align-items:center;
            justify-content: center;

        }
    }

    .phone-screen{

        background: url("/img/phone.png");
        display:flex;
        flex-direction: column;
        border-radius: 50px;
        border: 1px solid black;

        min-width: 379px;
        min-height: 736px;
        background-size:  379px 736px;
        background-repeat: no-repeat;
        margin:auto;
        overflow: hidden;
        &__content{

            overflow-y: auto;
            max-width: 382px;
            max-height: 595px;
            margin: auto !important;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: 0 15px;
        }
    }
    .main-carousel{
        position: relative;
        &__overlay{
            position: absolute;
            bottom:0;
            left:0;
            right:0;
            height: 45px;
            width: 100%;
            margin: auto !important;
            background:rgba(#000,0.5);
            color: #fff;
            text-align: center;

        }
    }
    .property-values{
        border: 1px solid #c29f52;
        border-radius: 30px;
        height: auto;
        padding: 0 10px;
        h3{
            color:#c29f52;
            font-weight: 900;

        }
        .price-tooltip{
            color:#c29f52;
            font-weight: bold;
            margin:auto;
            margin-top:-10px;
            max-width: 100px;
            border: 1px solid #c29f52;
            border-radius: 15px;
            border-top-right-radius: 0;
            border-top-left-radius: 0;
            border-top: none;
        }
    }
    .numPayments{
        background: white !important;
        border: 1px solid #777;
        border-radius: 25px;
        width:auto;
        max-width: fit-content;

        &__button{
            color:#000 !important;
            border-radius: 40px;
        }
    }
    .v-input--slider{
        margin-top:0;
    }
    .v-tabs__container{
        max-width: 100%;
        overflow-x: auto;

    }
    .property-sections{
        span,b{
            font-size: 15px !important;
        }

        .v-tab{
            color: black !important;
        }
    }
    .property-toolbar{

    }
</style>
